import { render } from "./history.vue?vue&type=template&id=cd8a089c&scoped=true"
import script from "./history.vue?vue&type=script&scoped=true&lang=js"
export * from "./history.vue?vue&type=script&scoped=true&lang=js"

import "./history.vue?vue&type=style&index=0&id=cd8a089c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd8a089c"]])

export default __exports__